import { StrapiActions, StrapiActionTypes, StrapiState } from "../../types/strapiMyTasks";

const initialState: StrapiState = {};

export const formAdd5SCard = (state = initialState, action: StrapiActions): StrapiState => {
  switch (action.type) {
    case StrapiActionTypes.ADD_REQUEST_MYTASKS: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.ADD_SUCCESS_MYTASKS: {
      const { modelName, data } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: [...(state[modelName]?.data || []), data],
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.ADD_FAILURE_MYTASKS: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.UPDATE_REQUEST_MYTASKS: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.UPDATE_SUCCESS_MYTASKS: {
      const { modelName, data } = action.payload;
      const existingData = state[modelName]?.data || [];
      const updatedData = existingData.map((item: any) =>
        item.id === data.id ? data : item
      );
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          data: updatedData,
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.UPDATE_FAILURE_MYTASKS: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    case StrapiActionTypes.DELETE_REQUEST_MYTASKS: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.DELETE_SUCCESS_MYTASKS: {
      const { modelName, documentId } = action.payload;
      const existingData = state[modelName]?.data || [];
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          data: existingData.filter((item: any) => item.documentId !== documentId),
          loading: false,
          error: null,
        },
      };
    }

    case StrapiActionTypes.DELETE_FAILURE_MYTASKS: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          ...state[modelName],
          loading: false,
          error,
        },
      };
    }

    default:
      return state;
  }
};
